export default "__VITE_ASSET__YK5CJHum__"